import Head from 'next/head'

import { BUSINESS_INFO } from '@/constants/business'

const LocalBusinessSchema = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': ['Store', 'FurnitureStore'],
    '@id': `${BUSINESS_INFO.url}/#store`,
    name: BUSINESS_INFO.name,
    url: BUSINESS_INFO.url,
    image: BUSINESS_INFO.image,
    telephone: BUSINESS_INFO.telephone,
    email: BUSINESS_INFO.email,
    address: {
      '@type': 'PostalAddress',
      ...BUSINESS_INFO.address
    },
    geo: {
      '@type': 'GeoCoordinates',
      ...BUSINESS_INFO.geo
    },
    openingHoursSpecification: BUSINESS_INFO.openingHours.map((spec) => ({
      '@type': 'OpeningHoursSpecification',
      ...spec
    })),
    sameAs: BUSINESS_INFO.sameAs,
    brand: {
      '@type': 'Brand',
      name: 'Henge',
      url: 'https://www.henge07.com/'
    }
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </Head>
  )
}

export default LocalBusinessSchema
